import { Parchment } from 'quill/core';

const usersSet = new Set<string>();

export const getUserSequence = (userId: string) =>
  (Array.from(usersSet.values()).indexOf(userId) % 6) + 1;

export const USER_SEQUENCE_ATTRIBUTE = 'data-user-sequence';

class UserSequence extends Parchment.Attributor {
  constructor(attrName = 'author', keyName = 'data-user') {
    super(attrName, keyName, {
      scope: Parchment.Scope.INLINE_ATTRIBUTE,
    });
  }

  add(node: HTMLElement, value: string) {
    if (!this.canAdd(node, value)) {
      return false;
    }
    usersSet.add(value);
    node.setAttribute(this.keyName, value);
    node.setAttribute(USER_SEQUENCE_ATTRIBUTE, `${getUserSequence(value)}`);
    return true;
  }

  remove(node: HTMLElement) {
    node.removeAttribute(this.keyName);
    node.removeAttribute(USER_SEQUENCE_ATTRIBUTE);
  }
}

export default new UserSequence();
